export const SETTINGSID = {
  ACTIVE: 1,
  FAVORITE: 2,
  SERVERLESS: 999
}

export const TRIALSTATUS = {
  NEVER: 1,
  CURRENT: 2,
  EXPIRED: 3,
  CANCELED: 4
}

export const SUBSCRIPTIONDURATIONIDS = {
  ANNUAL: 3,
  MONTHLY: 4
}

export const SUBIDS = {
  PRO: 4,
  HUNT: 8,
  PRO_ADVANTAGE: 36,
  PRO_ULTIMATE: 44
}

export const SUBSCRIPTIONS = {
  BASIC: 'Basic Subscription',
  PRO: 'Pro Subscription',
  PRO_ULTIMATE: 'Pro Ultimate Subscription',
  GLOBAL_RESCUE: 'Global Rescue Subscription',
  HUNTDATA: 'Hunt Data Subscription',
  PRO_ADVANTAGE: 'Pro Advantage Subscription'
}

// Measurement.MeasurementTypeID, mirroring the server's MeasurementType enum
// (services/Models/ModelEnums.cs). The server stores whatever id it is sent, so a
// wrong literal here saves a shape no client can find (WEB-7126).
export const MEASUREMENT_TYPES = {
  TRACK: 1,
  ROUTE: 2,
  POLYGON: 3,
  LINE: 4,
  CIRCLE: 5
}
